import React from 'react';
import 'swiper/swiper.scss';
import { history } from 'umi';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);


export default (props) => {

  const { bannerList } = props;

  return(
    <AutoPlaySwipeableViews>
      { bannerList.map(item => (
        <div key={item.id} style={{width: '100%', height: '200px'}}>
          <img
            style={{
              width: '100%',
              height: '200px',
              objectFit:'cover'
            }}
            src={item.image}
            onClick={() => {
              if (item.url) {
                //
                // history.push(item.url);
                window.location.href = item.url;
              }else {
                history.push({pathname:'/home/showContent',state:{data:item}});

              }

            }}
          />
        </div>
      ))}

    </AutoPlaySwipeableViews>
  )

}
